import { useTranslation } from 'react-i18next'

import empty_messages_icon from '../../assets/inbox/empty_messages_icon.webp'
import classNames from '../../utils/classNames'

// `className` replaces the full-page height so the same empty state can sit in
// a height-capped container (the inbox modal) without overflowing it.
const Empty = ({ className = 'h-[calc(100vh-185px)] xl:h-[500px]' }) => {
  const { t } = useTranslation('inbox')
  return (
    <div className={classNames('v-flx-ctr', className)}>
      <img
        src={empty_messages_icon}
        alt="Empty Messages"
        className="w-[140px] mb-[45px]"
      />
      <p className="text-sm xl:text-base text-secondary-txt leading-[18px] font-normal font-[Poppins]">
        {t('empty')}
      </p>
    </div>
  )
}

export default Empty
